export let jumpToButtonLabel = "zWrEib";
export let goButtonLabel = "ereW3b";
export let goButtonLabelDateTimeSort = "blwDMd";
export let jumpToDatePickerLabel = "bvfvU";
export let jumpToSenderInputPlaceholder = "jnjTLe";
export let jumpToSubjectInputPlaceholder = "I$t1kc";
export let jumpToRecipientInputPlaceholder = "dbqnue";
export let importanceNormal = "jBI75";
export let importanceLow = "GWeH0c";
export let importanceHigh = "ud1qWb";
export let dateToday = "b71ytd";
export let dateYesterday = "eOmWc";
export let dateLastWeek = "ENpzEe";
export let dateLastMonth = "spTlbe";
export let dateLastYear = "fQpqDb";
export let sizeTinyOption = "MiY0Ke";
export let sizeSmallOption = "pILUdd";
export let sizeMediumOption = "dSRdfe";
export let sizeLargeOption = "fFV$yc";
export let sizeVeryLargeOption = "Nl5Mie";
export let sizeHugeOption = "ToZsSb";
export let sizeEnormousOption = "Qu198";
export let categoryNoneOption = "lWt0r";
export default {jumpToButtonLabel,goButtonLabel,goButtonLabelDateTimeSort,jumpToDatePickerLabel,jumpToSenderInputPlaceholder,jumpToSubjectInputPlaceholder,jumpToRecipientInputPlaceholder,importanceNormal,importanceLow,importanceHigh,dateToday,dateYesterday,dateLastWeek,dateLastMonth,dateLastYear,sizeTinyOption,sizeSmallOption,sizeMediumOption,sizeLargeOption,sizeVeryLargeOption,sizeHugeOption,sizeEnormousOption,categoryNoneOption};